import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { loginAction, changePasswordAction, getAllAuthoritiesAction } from "../action/loginAction";
import { login, } from "@/api/modules/login";
export const loginReducer = (builder: ActionReducerMapBuilder<{
  loginDetail: any,
  changePassword: any;
  getAllAuthoritiesConfig: any
}>) => {
  builder.addCase(loginAction.fulfilled, (state, { payload }) => {
    state.loginDetail = payload
    // // 存储uid
    payload?.data?.user_uid && localStorage.setItem("user_uid", payload?.data?.user_uid);

    payload?.data?.accessToken &&
      localStorage.setItem("come-to-chant-token", payload?.data?.accessToken);
  });
  builder.addCase(changePasswordAction.fulfilled, (state, { payload }) => {
    // 存储uid
    state.changePassword = payload;
  });

  builder.addCase(getAllAuthoritiesAction.fulfilled, (state, { payload }) => {
    // 存储uid
    state.getAllAuthoritiesConfig = payload;
  });
};
